import React, { Fragment, useState } from "react";
import { recievedNotification } from "../../../Store/api/activities";
import { useDispatch, useSelector } from "react-redux";
export default function Notifications() {
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [notificationValue, setNotificationValue] = useState(
    user.recieveNotification
  );
  const dispatch = useDispatch();
  /* ................... */
  const handleSaveNotfication = () => {
    // Call the API to update the profile
    setIsEditing((e) => !e);
    const updatedNotification = {
      recieveNotification: notificationValue,
    };
    if (isEditing) {
      dispatch(
        recievedNotification({
          body: updatedNotification,
          onSuccess: (res) => {},
          onError: (err) => {
            // Handle error as needed
          },
        })
      );
    }
  };

  const handleRadioChange = (value) => {
    setNotificationValue(value === "yes");
  };
  /* ...................... */

  return (
    <div className="box_border_settings border-grey">
      <div className="settings_header">
        <h2>notification settings</h2>
        <div className="settings_header">
          <p className="mb-0 editt cursor" onClick={handleSaveNotfication}>
            {isEditing ? "editing" : "edit"}
          </p>
        </div>
      </div>
      <div className="setting_rows">
        <p className="key" style={{ width: "60%" }}>
          Receive notifications by email
        </p>

        {isEditing ? (
          <Fragment>
            <span style={{ width: "10%" }}></span>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <label htmlFor="yes">
                Yes
                <input
                  type="radio"
                  name="noti"
                  id="yes"
                  value={true}
                  checked={notificationValue === true}
                  className="custome_radio cursor"
                  onChange={() => handleRadioChange("yes")}
                />
                <span></span>
              </label>
              <label htmlFor="no">
                No
                <input
                  type="radio"
                  name="noti"
                  id="no"
                  value={false}
                  className="custome_radio cursor"
                  checked={notificationValue === false}
                  onChange={() => handleRadioChange("no")}
                />
                <span></span>
              </label>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <span style={{ width: "30%" }}></span>
            <div
              className="value"
              style={{
                width: "10%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {user.recieveNotification === true ? "Yes" : "No"}
            </div>
          </Fragment>
        )}
      </div>
      {isEditing && (
        <div className="setting_rows" style={{ marginBottom: "0px" }}>
          <p className="key"></p>
          <p className="value">
            <p className="main_part"></p>
            <p className="edit_buttton">
              <span>Save --&gt;</span>
            </p>
          </p>
        </div>
      )}
    </div>
  );
}
